import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectExternalLink(
    request: Boundaries["editProjectExternalLink"]["request"],
  ): void;
}

function useEditProjectExternalLink(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isEditProjectExternalLinkRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isEditProjectExternalLinkRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isEditProjectExternalLinkRequestFailure,
    ),
    editProjectExternalLink: core.editProjectExternalLink,
  };
}

export { useEditProjectExternalLink };
